import { createSelectors as createFormWidgetSelectors } from '../../components/Form/Widget';

import * as constants from './constants';

export const root = state => state.getIn(['Resources', 'view']);
export const mainForm = createFormWidgetSelectors(constants.RESOURCE_FORM_MAIN)(root);
export const placesForm = createFormWidgetSelectors(constants.RESOURCE_PLACES_FORM)(root);
export const externalForm = createFormWidgetSelectors(constants.RESOURCE_EXTERNAL_FORM)(root);
export const filesForm = createFormWidgetSelectors(constants.RESOURCE_FILES_FORM)(root);
